import React from 'react';
import { Sunrise } from 'react-feather';

interface AppIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const AppIcon: React.FC<AppIconProps> = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`
      ${sizes[size]}
      rounded-lg
      bg-gradient-to-br from-green-500 to-emerald-600
      text-white
      flex items-center justify-center
      shadow-md
      ${className}
    `}>
      <Sunrise className={size === 'sm' ? 'w-4 h-4' : size === 'md' ? 'w-5 h-5' : 'w-8 h-8'} />
    </div>
  );
};

export default AppIcon;